import { memo, useMemo } from "react";
import { isEmojiOnlyStr } from "src/helpers/emojiHelpers/emojiHelpers";
import { Text } from "src/swsh-native";
import useGatheringNameFontSize from "../hooks/useGatheringNameFontSize";
import { GatheringHeaderProps } from "../types";

const GatheringHeaderName = ({
	name,
	renderName,
}: Pick<GatheringHeaderProps, "name" | "renderName">) => {
	const fontSize = useGatheringNameFontSize(name ?? "");
	const shouldItalicize = useMemo(() => !isEmojiOnlyStr(name), [name]);

	if (name && renderName) {
		return renderName({
			name,
			fontSize,
			textStyle: {
				fontWeight: "700",
				fontSize,
			},
		});
	} else {
		return (
			<Text
				italic={shouldItalicize}
				bold
				style={{
					fontSize,
				}}
				testID="AlbumName"
			>
				{name ?? ""}
			</Text>
		);
	}
};
export default memo(GatheringHeaderName);
